import React from "react";
import { Navbar, Container, Nav, Image, Dropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaBell } from "react-icons/fa";
import logo from "../../../assets/logo/logo.svg";

const Header = ({ userData, logout }) => {
  return (
    <>
    <Navbar bg="light" expand="lg" className="px-3 shadow-sm">
      <Container fluid>
        <Navbar.Brand>
          <Image src={logo} alt="Agilisium Logo" height="40" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className="justify-content-end">
          <Nav className="align-items-center">
            <FaBell
              size={"1.4em"}
              className="m-1 me-2"
              style={{ cursor: "pointer" }}
            />
            <Dropdown>
              <Dropdown.Toggle variant="white">
                {userData?.displayName}
              </Dropdown.Toggle>
              <Dropdown.Menu align="end">
                <Dropdown.Item 
                onClick={logout}
                >Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
};

export default Header;
